import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import votante from '../fetchs/votante';
import { marcaDestinoVotacao } from './destinoVotacao';


export class LinkUnico extends React.Component {
    state = {
        msgErro: '',
        msgType: null,
        ehLinkUnico: false
    }

    componentDidMount = async () => {
        const searchParams = new URLSearchParams(this.props.location.search);
        const evento = this.props.evento;
        const votanteId = searchParams.get('votanteId');
        const auth = searchParams.get('auth');

        if (votanteId && auth) {
            this.setState({ ehLinkUnico: true });
        } else {
            return;
        }

        const autentica = await votante.fetchAutentica(evento, {
            votanteId: parseInt(votanteId),
            auth: auth
        });

        switch (autentica.status) {
            case 404:
            case 401:
                this.setState({msgType:'warning', msgErro: autentica.data.mensagem });
                break;
            case 200:
                // PANG-293: o link gerado pelo botão "Panágora na Sala" carrega destino=votacao.
                // Persistimos a intenção em sessionStorage (o param se perde quando o login navega
                // para "/") e é consumida (one-shot) ao redirecionar para a urna em EventoIndex.
                // Gravamos só APÓS a autenticação: o bootstrap dispara um logout transitório que
                // limpa a flag (logoutUser), então gravar antes do onLogin a perderia.
                if (searchParams.get('destino') === 'votacao') {
                    marcaDestinoVotacao();
                }
                this.props.onLogin(autentica.data.nome, autentica.data.tokenTemporario, 'link_unico');
                break;
            default:
                console.error(autentica.data);
                alert('Ops.. Erro ao efetuar a autenticação, tente novamente mais tarde');
                break;
        }
    }

    render() {
        if (!this.state.ehLinkUnico) {
            return this.props.children;
        }

        if (this.state.msgErro) {
            return (
                <div className="w-25 mx-auto text-center mt-3">
                    <Alert variant={this.state.msgType}>{this.state.msgErro}</Alert>
                </div>
            );
        }

        return (
            <div className="text-center mt-3">
                <Spinner variant="primary2" animation="border" role="status">
                    <span className="sr-only">Autenticando</span>
                </Spinner>
                <div className="text-muted">Autenticando...</div>
            </div>
        );
    }
}


const mapStateToProps = store => ({
    evento: store.eventoState.evento.item
});




export default connect(mapStateToProps)(withRouter(LinkUnico)); 